import React from 'react';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const ConditionButton = ({className, children, onClick}) => (
    <button className={classNames(className, 'condition-button btn')} type="button" onClick={onClick}>
        <FontAwesomeIcon icon="fa-cog" fixedWidth={true} />
        {children && <span className="ml-1">{children}</span>}
    </button>
);

export default ConditionButton;
